import { useContext } from "react";
import { Alert, Tag } from "antd";
import WhiteLabelAvatar from "../../components/WhiteLabelAvatar";
import { ICompany } from "../../interfaces/company";
import { FreireContext } from "../../utils/freireContext";
import * as texts from "./locales";
import { useWhitelabels } from "../../components/WhitelabelThemesProvider";

type Props = {
  allowedApps: string[];
  parentCompany: ICompany;
};

const AlertAllowedApps = ({
  allowedApps,
  parentCompany,
}: Props) => {
  const { freire } = useContext(FreireContext);
  const { getWhitelabelByAlias } = useWhitelabels();

  const companyHasAllowedApps = allowedApps?.length > 0;
  const parentCompanyHasAllowedApps = parentCompany?.allowed_apps?.length > 0;

  if (!companyHasAllowedApps && !parentCompanyHasAllowedApps) {
    return null;
  }

  return (
    <Alert
      type="warning"
      style={{ marginBottom: 10 }}
      message={
        companyHasAllowedApps ? (
          <span>
            {freire(texts.COMPANY_CUSTOM_ALLOWED_APPS_NOTICE)}{" "}
            <b>{parentCompany?.companyName}</b>
          </span>
        ) : (
          <span>
            {freire(texts.PARENT_ALLOWED_APPS_NOTICE)}{" "}
            <b>{parentCompany?.companyName}:</b>
            <br />
            <br />
            {parentCompany.allowed_apps.map((allowed_app: string) => {
              const whiteLabel = getWhitelabelByAlias(allowed_app)
              if (!whiteLabel) return null;
              return (
                <Tag
                  key={whiteLabel.alias}
                  style={{ marginRight: 4, padding: "2px 7px" }}
                >
                  <WhiteLabelAvatar whitelabel={whiteLabel} sizeIcon={20} />
                </Tag>
              );
            })}
            <br />
            <br />
            <b>{freire(texts.CUSTOM_ALLOWED_APPS_INSTRUCTION)}</b>
          </span>
        )
      }
    />
  );
};

export default AlertAllowedApps;
